import './LayoutSkeleton.scss';
import { Skeleton } from 'antd';
import { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/alkemy/logo.png';
import { t } from '../../i18n/i18n';
import { HOME } from '../../constants/routes';

const LayoutSkeleton = () => {
  const [showRealLogo, setShowRealLogo] = useState(false);
  const headerRef = useRef(null);

  useEffect(() => {
    if (headerRef.current) {
      // Use requestAnimationFrame to ensure the DOM has been painted
      const rafId = requestAnimationFrame(() => {
        setShowRealLogo(true);
      });

      // Cleanup: cancel the animation frame if component unmounts
      return () => {
        cancelAnimationFrame(rafId);
      };
    }
  }, []);

  return (
    <div className="layout-skeleton-wrapper">
      <div
        ref={headerRef}
        className="header d-flex align-items-center justify-content-between flex-wrap px-xs-2 px-1"
      >
        <div className="d-flex align-items-center flex-wrap py-1">
          {showRealLogo ? (
            <Link to={HOME}>
              <img src={logo} className="logo mr-sm-4" alt={t('HEADER_LOGO')} />
            </Link>
          ) : (
            <Skeleton.Input active className="skeleton-logo mr-sm-4" />
          )}
          <div className="d-none d-md-inline header-vertical-line mr-sm-4" />
        </div>
        <div className="d-flex align-items-center gap-3">
          <Skeleton.Button active className="skeleton-header-icon" />
          <Skeleton.Button active className="skeleton-header-icon" />
          <Skeleton.Button active className="skeleton-header-icon" />
          <Skeleton.Button active className="skeleton-header-button" />
          <div className="d-flex align-items-center">
            <Skeleton.Avatar active size={32} />
            <Skeleton.Input active className="skeleton-header-user-text" />
          </div>
        </div>
      </div>

      <div className="sidebar position-fixed h-100 non-selectable close-sidebar d-none d-lg-block">
        <div className="my-2 d-flex justify-content-center">
          <Skeleton.Button active className="skeleton-sidebar-icon" />
        </div>

        <div className="nav-links">
          <div className="my-4 d-flex justify-content-center">
            <Skeleton.Avatar active size={32} />
          </div>
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <div key={item} className="mb-3 d-flex justify-content-center">
              <Skeleton.Button active className="skeleton-nav-icon" />
            </div>
          ))}
        </div>

        <div className="position-absolute" style={{ bottom: 20, width: '100%' }}>
          <div className="d-flex justify-content-center">
            <Skeleton.Button active className="skeleton-nav-icon" />
          </div>
        </div>
      </div>

      <div className="skeleton-content-area">
        <div className="w-100 px-4 py-4">
          <Skeleton.Input active block className="mb-2" style={{ height: '16px', width: '100%' }} />
          <Skeleton.Input active block className="mb-4" style={{ height: '16px', width: '85%' }} />

          <Skeleton.Button active block className="mb-3" style={{ height: '100px' }} />

          <Skeleton.Input active block className="mb-2" style={{ height: '16px', width: '100%' }} />
          <Skeleton.Input active block className="mb-2" style={{ height: '16px', width: '95%' }} />
          <Skeleton.Input active block className="mb-2" style={{ height: '16px', width: '90%' }} />
          <Skeleton.Input active block className="mb-2" style={{ height: '16px', width: '100%' }} />
          <Skeleton.Input active block className="mb-2" style={{ height: '16px', width: '88%' }} />
          <Skeleton.Input active block style={{ height: '16px', width: '92%' }} />
        </div>
      </div>
    </div>
  );
};

export default LayoutSkeleton;
